import { Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { LocationsGroupsService } from 'app/main/locations-groups/services/locations-groups-resolver.service';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { LocationGroup } from '../../../../interfaces';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export function ValidateAutocomplete(): object {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LocationGroupLegacyComponent),
  multi: true
};

@Component({
  selector: 'location-group-legacy',
  templateUrl: './location-group.component.html',
  styleUrls: ['./location-group.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class LocationGroupLegacyComponent implements ControlValueAccessor, OnInit {
  public locationsGroups = new Array<LocationGroup>();
  public inputValue = new FormControl();
  public selectedLocationGroup: LocationGroup;
  public hasSelectedLocationGroup: boolean;
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private locationsGroupsApi: LocationsGroupsService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {
    this.inputValue.valueChanges
      .pipe(
        filter((searchTerm) => {
          return !!searchTerm;
        }),
        debounceTime(500),
        switchMap((searchTerm) => {
          this.loading = true;
          this.locationsGroups = [];
          return this.locationsGroupsApi.getLocationsGroups({
            where: {
              name_contains: searchTerm,
              archived: false
            },
            options: {
              orderBy: 'name_asc',
              offset: 0,
              limit: 10
            }
          });
        })
      )
      .subscribe((result) => {
        this.loading = false;
        this.locationsGroups = result.items;
      });
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  writeValue(locationGroupId: any): void {
    if (locationGroupId) {
      this.locationsGroupsApi.getLocationGroup(locationGroupId)
        .then((locationGroup) => {
          this.selectedLocationGroup = locationGroup;
          this.hasSelectedLocationGroup = true;
          this.inputValue.setErrors(null);
        });
    } else {
      this.deselectLocationGroup();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedLocationGroup(): void {
    if (this.inputValue.value) {
      this.inputValue.setErrors(null);
      this.onChange(this.inputValue.value);

      this.selectedLocationGroup = this.locationsGroups
        .find((locationGroup) => locationGroup.id === this.inputValue.value) as LocationGroup;

      this.hasSelectedLocationGroup = true;
    }
  }

  deselectLocationGroup(): void {
    this.onChange(null);

    this.inputValue.setValue(null);
    this.inputValue.setErrors(null);

    this.selectedLocationGroup = null;
    this.hasSelectedLocationGroup = false;
  }
}
